import React from "react";
import "./Payment.css"; // Import CSS file for styles

const cards = [
  { id: 1, images: '/images/upi.jpg' },
  { id: 2, images: '/images/master-card.png' },
  { id: 3, images: '/images/bank-transfer.png' },
  { id: 4, images: '/images/visa.png' },
  { id: 5, images: '/images/skrill.png' },
  { id: 6, images: '/images/net-banking.png' },
];

const Payment = () => {
  return (
    <div className="payment-container">
    <div className="payment-slider">
      <div className="slider">
        {/* Duplicate cards multiple times for seamless effect */}
        {[...cards, ...cards, ...cards, ...cards, ...cards, ...cards].map((card, index) => (
          <div key={index} className="payment-card">
            <img src={card.images} alt={`Card ${card.id}`} />
          </div>
        ))}
      </div>
    </div>
    </div>
  );
};

export default Payment;
